import React, { FC } from 'react'
import { HelpCenterComponents } from '@izettle/public-site-components/dist/help-center'

type Props = {
  content: any
}

const Component: FC<Props> = ({ content }) => {
  if (typeof HelpCenterComponents[content.component] !== 'undefined') {
    const Component = HelpCenterComponents[content.component]
    return <Component key={content._uid} content={content} />
  }
  return <span>not found {content.component}</span>
}

export default Component
